import { render, staticRenderFns } from "./TextAreaWithLable.vue?vue&type=template&id=06c64c7a&scoped=true&"
import script from "./TextAreaWithLable.vue?vue&type=script&lang=js&"
export * from "./TextAreaWithLable.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaWithLable.vue?vue&type=style&index=0&id=06c64c7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c64c7a",
  null
  
)

export default component.exports